<template lang="pug">
  overlay.px-15.md-px-120.flex.justify-center.overflow-y-scroll.scrolling-touch(@close="close")
    .pt-164.pb-60.md-py-40.my-auto.xl-w-1x3
      header.mb-60.md-mb-120.text-center
        h4.text-24.leading-none Join our mailing list
      //- thank you
      template(v-if="success")
        .my-120.md-my-164.text-center.text-15.md-text-17.cursor-pointer(@click="reset") Thank you.
        footer.text-center
          button(@click="close")
            btn.min-w-btn-sm Close
      //- form
      form.max-w-400(validate, @submit.prevent="submit", v-show="!success")
        .text-15.md-text-13
          //- errors
          .mb-24.text-center.text-blue(v-if="error") {{error}}
          //- fields
          .border-t.md-border-none
            label.reader-show Email Address
            input.block.w-full.border-b.py-15.md-py-6.px-10(v-model="formData.email", name="email", placeholder="Email Address", type="email", required)
          .md-mt-8
            label.reader-show First Name
            input.block.w-full.border-b.py-15.md-py-6.px-10(v-model="formData.fname", name="first name", placeholder="First Name", type="text", required)
          .md-mt-8
            label.reader-show Last Name
            input.block.w-full.border-b.py-15.md-py-6.px-10(v-model="formData.lname", name="last name", placeholder="Last Name", type="text", required)
          .mt-30.flex.flex-row-reverse
            label.block.flex-1.pl-15 I agree to my personal data being stored and used for distribution of the Blue Mountain School newsletter.
            input.mr-2.text-gray-300(type="checkbox", v-model="formData.consent_to_store_personal_data", required)
          .mt-15.flex.flex-row-reverse
            label.block.flex-1.pl-15 I agree to receive information and commercial offers about Blue Mountain School.
            input.mr-2.text-gray-300(type="checkbox", v-model="formData.consent_to_receive_offers", required)
        //- submit
        .mt-60.md-mt-120.flex.justify-center
          button.w-full.max-w-submit-btn.md-w-auto.md-min-w-btn(type="submit")
            btn(type="submit") Subscribe
</template>

<script>
import Overlay from '@/components/Overlay'
import Btn from '@/components/Btn'
import { mapMutations } from 'vuex'
export default {
  name: 'Subscribe',
  components: { Overlay, Btn },
  data () {
    return {
      formData: {
        email: '',
        fname: '',
        lname: '',
        consent_to_store_personal_data: '',
        consent_to_receive_offers: ''
      },
      success: null,
      error: null
    }
  },
  methods: {
    ...mapMutations({ show: 'SET_SUBSCRIBE' }),
    reset () {
      this.success = this.error = null
    },
    close () {
      this.show(false)
      this.reset()
    },
    submit () {
      this.error = null
      this.$store.dispatch('addSubscriber', this.formData)
        .then(() => { this.success = true })
        .catch(err => {
          this.error = err.message ? err.message.replace('Error: ', '') : 'Error'
        })
    }
  }
}
</script>

<style>
@import '../style/_settings.css';
input[type="checkbox"]{
  cursor: pointer;
  appearance:none;
  width:2rem;
  height:2rem;
  display:inline-block;
  border:1px solid currentColor;
  border-radius: 5px;
  &:checked{
    color:var(--gray-300);
    background-color:currentColor;
  }
}
</style>
